import axiosApiInstance from '../../interceptors/axiosApiInstance';
import { BASE_URL } from '../config';

const LogService = {
    downloadAdvancedLogs: async function (operation_id) {
        try {
            const response = await axiosApiInstance.get(await BASE_URL + `/log/advanced/download`, {
                params: {
                    operation_id
                }
            });
            return response.data;
        } catch (error) {
            return error.response ? error.response.data : undefined;
        }
    },
    getLogsByGroupId: async function (operation_id, groupId) {
        try {
            const response = await axiosApiInstance.get(await BASE_URL + `/log/group/${groupId}`, {
                params: {
                    operation_id: operation_id
                }
            });
            return response.data;
        } catch (error) {
            return error.response ? error.response.data : undefined;
        }
    },
    getLogEntriesByGroupId: async function (operation_id, groupId) {
        try {
            const response = await axiosApiInstance.get(await BASE_URL + `/log/entries/${groupId}`, {
                params: {
                    operation_id: operation_id
                }
            });
            return response.data;
        } catch (error) {
            return error.response ? error.response.data : undefined;
        }
    },
    getSummaryLogBreadCrumb: async function (operation_id, itemsPerPage, parent_id, group_id) {
        try {
            const response = await axiosApiInstance.get(await BASE_URL + `/log/breadcrumb`, {
                params: {
                    operation_id,
                    itemsPerPage,
                    parent_id,
                    group_id
                }
            });
            return response.data;
        } catch (error) {
            return error.response ? error.response.data : undefined;
        }
    },
    searchLog: async function (params) {
        try {
            const response = await axiosApiInstance.get(await BASE_URL + `/log/search`, { params });
            return response.data;
        } catch (error) {
            return error.response ? error.response.data : undefined;
        }
    },
    checkLogsBefore: async function (operation_id, duration = 30) {
        try {
            const response = await axiosApiInstance.get(await BASE_URL + `/log/check/${duration}`, { params: { operation_id } });
            return response.data;
        } catch (error) {
            return error.response ? error.response.data : undefined;
        }
    }
};

export default LogService;
